import React from "react";

import Select from "react-select";

import { Icon } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export default class ChooseSuccess extends React.PureComponent {
  render() {
    const {
      outcome,
      options,
      successOptionsWarning,
      success,
      endState,
      updateEndState,
      updateSplitColumn,
      splitOptions,
      selectedDataset,
      isShow,
      id,
      updateSuccess
    } = this.props;

    if (selectedDataset === undefined) {
      return <div className={styles.emptyMsg}>{"Dataset not selected"}</div>;
    }

    return (
      <div className={styles.outcomeOptions} style={{ opacity: isShow === true ? 1 : 0 }}>
        <div id="outcomeSelect">
          <AibleStep
            id={id}
            bId="chooseSuccess"
            message={"Which value of " + selectedDataset.outcome + " do you want to predict?"}
            secondaryMessage={
              "This is typically an outcome that you want to identify so you can take " +
              "action to increase the frequency of good outcomes, or decrease the frequency of bad outcomes."
            }
            isBreak
          >
            <div className={styles.optionsSelect}>
              <div>{"Predict " + selectedDataset.outcome + " is:"}</div>
              {options && options.length === 2 ? (
                <Select
                  key={success ? "success" : "undefined"}
                  value={success}
                  onChange={(value) => updateSuccess(value)}
                  options={options}
                  className={styles.outcomePicker}
                  placeholder="Select Value"
                  menuPlacement="top"
                />
              ) : (
                <Select
                  key={success ? "success" : "undefined"}
                  value={success}
                  onChange={(value) => updateSuccess(value)}
                  options={options}
                  className={styles.outcomePicker}
                  placeholder="Select Value"
                  menuPlacement="top"
                  isMulti
                />
              )}
              {successOptionsWarning ? (
                <div className={styles.successWarning}>
                  <Icon type={"warning"} size={14} style={{ display: "inline-block" }} />
                  <span>{successOptionsWarning}</span>
                </div>
              ) : (
                ""
              )}
            </div>
          </AibleStep>
        </div>
        {isEnabled("end-state-selection") && (
          <AibleStep
            id={id}
            bId="chooseEndState"
            message={"Which values of " + selectedDataset.outcome + " determines an end state?"}
            secondaryMessage={""}
            isBreak
          >
            <div className={styles.optionsSelect}>
              <Select
                value={endState}
                onChange={(value) => updateEndState(value)}
                options={
                  selectedDataset &&
                  selectedDataset.fields &&
                  selectedDataset.outcome &&
                  selectedDataset.fields[selectedDataset.outcome]
                    ? selectedDataset.fields[selectedDataset.outcome].data.map((d) => ({
                        label: d.value,
                        value: d.value
                      }))
                    : []
                }
                className={styles.outcomePicker}
                placeholder="Select Value(s)"
                menuPlacement="top"
                isMulti
              />
            </div>
          </AibleStep>
        )}
      </div>
    );
  }
}
